export const PAGINATION_OPTIONS = [60, 30, 15] as const;
export const DEFAULT_ITEMS_PER_PAGE = 60;
export const MAX_TAGS_DISPLAY = 3;

export const DEFAULT_VIEW_TYPE = "files" as const;

export const ZOOM_LEVELS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4] as const;
export const DEFAULT_ZOOM = 1;
export const MIN_ZOOM = 0.1;
export const ZOOM_STEP = 1.5;

export const SORTABLE_COLUMNS = {
  name: "Name",
  extension: "Extension",
  fileSize: "FileSize",
  createdDate: "CreatedDate",
  viewCount: "ViewCount",
} as const;

export type SortableColumn = keyof typeof SORTABLE_COLUMNS;
export type ApiSortColumn = (typeof SORTABLE_COLUMNS)[SortableColumn];
